export default __webpack_public_path__ + "static/media/163.7f0489c2.jpg";